document.addEventListener("DOMContentLoaded", () => {
	//init animations
	initGranimate();
});

function initGranimate(){
	// console.log("initGranimate()");

	//init ScrollMagic
	var controller = new ScrollMagic.Controller();

	//loop thru all .granimated sections
	const granimations = document.querySelectorAll('.granimate-me');
	granimations.forEach(function(granimation){
		//find all gran- classes
		granimation.querySelectorAll("[class*='gran-']").forEach(function($element, index){
			const delay = ($element.getAttribute("data-gran-delay")!="") ? parseInt($element.getAttribute("data-gran-delay")) : 0;
			const speed = ($element.getAttribute("data-gran-speed")!="") ? $element.getAttribute("data-gran-speed") : ''; //slow, slower, fast, faster
			const scene = new ScrollMagic.Scene({triggerElement: $element, triggerHook: 'onEnter', offset: 0, reverse: false})
				.addTo(controller)
				.on("enter", function (e) {
					if($element.classList.contains('gran-fadein')){
						granFadeIn($element, delay, speed);
					}
					else if($element.classList.contains('gran-fadeinup')){
						granFadeInUp($element, delay, speed);
					}
					else if($element.classList.contains('gran-sequence')){
						granSequence($element, delay, speed);
					}
					// else if($element.classList.contains('gran-slideinup')){
					// 	granSlideInUp($element, delay, speed);
					// }
					// else if($element.classList.contains('gran-slideindown')){
					// 	granSlideInDown($element, delay, speed);
					// }
					else if($element.classList.contains('gran-zoomin')){
						granZoomIn($element, delay, speed);
					}
					else if($element.classList.contains('gran-custom')){
						granCustom($element, delay);
					}
					else if($element.classList.contains('gran-parallax')) {
						const direction = $element.getAttribute("data-gran-direction") || 'down';
						const $pin = $element.getAttribute("data-gran-pin");
						granParallax($element, $pin);
					}
				});
		});
	});
}

function granSpeedClass(speed){
	//todo make this accept an int rather than slow, slower, fast, faster (settings from animate.css)
	return (speed != '' && !undefined) ? 'animate__' + speed : ''; //slow, slower, fast, faster
}

function granParallax($element, $pin) {
	// console.log('gran parallax triggered.', $element.offsetHeight);
	const parallaxScene = new ScrollMagic.Scene({
			triggerElement: $element,
			// triggerElement: $pin,
			// duration:  window.innerHeight, // the scene should last for a scroll distance of 100px
			duration:  $element.offsetHeight * 2, // the scene should last for a scroll distance of 100px
			offset: 0, // start this scene after scrolling for 50px
		})
		// .setTween(".background", {y: "80%", ease: "ease-in"})
		.setPin($pin) // pins the element for the the scene's duration
		.addTo(controller); // assign the scene to the controller
}

function granFadeIn($element, delay, speed){
	// console.log('granFadeIn()', $element);
	setTimeout( function(){ $element.classList.add('animate__animated', 'animate__fadeIn', granSpeedClass(speed)); }, delay );
	//granChainNext($element);
}

function granFadeInUp($element, delay, speed){
	// console.log('granFadeInUp()');
	setTimeout( function(){ 
		$element.classList.add('animate__animated', 'animate__fadeInUp', granSpeedClass(speed));
	}, delay );
	//granChainNext($element);
}

function granSequence($element, delay, speed){
	// console.log('granSequence()');
	var origSpeed = 500; //default speed
	var selector = ($element.getAttribute("data-gran-selector")!="") ? $element.getAttribute("data-gran-selector") : 'li';
	if (selector == null) selector = 'li';
	// console.log('selector', selector);
	switch(speed){
		case 'slow':
			origSpeed = 1000;
			break;
		case 'slower':
			origSpeed = 1500;
			break;
		case 'fast':
			origSpeed = 350;
			break;
		case 'faster':
			origSpeed = 150;
			break;
	}
	var interval = origSpeed;
	setTimeout( function(){
		$element.querySelectorAll(selector).forEach(function($li){
			setTimeout( function(){ 
								$li.classList.add('animate__animated', 'animate__fadeIn');
							}, interval);
			interval += origSpeed;
		});

	}, delay );
	//granChainNext($element);
}

function granZoomIn($element, delay, speed){
	//console.log('granZoomIn()');
	setTimeout( function(){ $element.classList.add('animate__animated', 'animate__zoomIn', granSpeedClass(speed)); }, delay );
	//granChainNext($element);
}

let customTriggered = false;
function granCustom($element, delay){
	const toEval = $element.getAttribute("data-gran-custom");
	// console.log('granCustom()', toEval, $element, delay);
	setTimeout( function(){
		eval( toEval + "($element)" ); 

		//register resize handler (debounce function is below)
		window.addEventListener('resize', function() {
			customTriggered = false;
			debounce(function() {
				eval( toEval + "($element)" );
			});
		});

		window.onscroll = function(e) {
			debounce(function() {
				eval( toEval + "($element)" );
			});
		}
	}, delay );

}

function granChainNext($element, $target, fn){
	//todo eval fn at $target
}

function granDash($element) {
	var selector = ($element.getAttribute("data-gran-selector")!="") ? $element.getAttribute("data-gran-selector") : $element;// TODO: not sure this default will work, hasn't been tested
	const animateMe = $element.querySelector(selector);
	animateMe.style.opacity = 1;
	setTimeout(function() {
		var bPaths = animateMe.querySelectorAll('.b');
		bPaths.forEach(function(b) {
			b.style.opacity = 1;
		});
	}, 5000);
	const path = animateMe.querySelector('path');
	path.classList.add('dash');
}

function granBlindersFake($element){
	// console.log("granBlindersFake(" + $element + ")");
	function setGranBlindersFake() {

		$element.querySelectorAll('.blinders').forEach(function($this) {
			//span the lines if not added manually
			if($this.classList.contains("autospan")){
				//add div to do some measuring
				const measureSpan = document.createElement("span");
				measureSpan.classList.add('textMeasure');
				measureSpan.style.whiteSpace = 'nowrap';
				measureSpan.setAttribute('nowrap', 'nowrap');
				measureSpan.textContent = $this.textContent.trim();
				$this.appendChild(measureSpan);
				
				// var containerWidth = $this.clientWidth;// not working for some reason, using closest measurable element hack below
				var $faker = $this.closest('.fake-container--left'),
					containerWidth = $faker.clientWidth,
					fakerStyle = window.getComputedStyle($faker),
					fakerPadding = parseInt(fakerStyle.getPropertyValue('padding-left')),
					fakerDiff = (containerWidth - fakerPadding) * .75;
	
				if (containerWidth == 0) {
					// fakerDiff = fakerPadding * 1.825;//width is 0 but padding is the same, weird.
					customTriggered = false;
				} else {
					customTriggered = true;
				}
				// console.log('clientw', fakerPadding, fakerDiff);
				
				var textArr = $this.querySelector(".textMeasure").textContent.trim().split(" ");
	
				const tempSpan = document.createElement("span");
				tempSpan.classList.add('tempMeasure');
				tempSpan.style.whiteSpace = 'nowrap';
				tempSpan.setAttribute('nowrap', 'nowrap');
				// tempSpan.style.fontSize = '65px';
				$this.appendChild(tempSpan);
				
				var $tempMeasure = $this.querySelector(".tempMeasure");
				// var tempWidth = 0;
				var tempText = "";
				var spans = new Array();
				var currentSpan = 0;
				
				//for each word, add it to the tempMeasure and keep measuring that it'll fit
				for(var i=0; i<textArr.length; i++){
					tempText = tempText + " " + textArr[i];
					$tempMeasure.textContent = tempText;
					// console.log('tm', $tempMeasure.offsetWidth, fakerDiff);
					if( $tempMeasure.offsetWidth >= fakerDiff ){
						tempText = textArr[i]; //start new span
						currentSpan++;
					}
					spans[currentSpan] = tempText;
				}
				
				//for each spans[j], wrap em into <span> and replace $this.html()
				var newHtml = "";
				for(var j=0; j<spans.length; j++){
					if (spans[j]) {
						newHtml = newHtml + '<span class="stack">' + spans[j].trim() + '</span> ';
					}
				}
				$this.innerHTML = newHtml;
			}
		});
	
		
		
		//handle manual spans
		$element.querySelectorAll(".blinders span").forEach(function($this){
			$this.classList.add('stack');
		});
	
		//prop things open so we can reclaim the space the abspos stuff should have taken
		$element.querySelectorAll(".blinders").forEach(function($this){
			var thisStyle = window.getComputedStyle($this),
				lineHeight = thisStyle.getPropertyValue('line-height'),
				numSpans = $this.querySelectorAll(".stack").length;
			// console.log("lineheight: "+ lineHeight);
			//artifical space for how high the H1 should have been
			$this.style.height = (parseInt(lineHeight)*numSpans) + "px"; 
		});
	
		//set the blinders visible again
		$element.querySelectorAll(".blinders").forEach(function($this){
			$this.style.visibility = "visible";
			// console.log('on', $element);
		});
	
		//do the blinders animation
		blinderStackSpans($element);
	}
	if (!customTriggered) {
		setGranBlindersFake();
	}
	// reinit blinders animation to allow room for all text 
	window.addEventListener('resize', setGranBlindersFake);

}

function granBlinders($element){
	// console.log("granBlinders(" + $element + ")");
	$element.querySelectorAll('.blinders').forEach(function($this) {
		//span the lines if not added manually
		if($this.classList.contains("autospan")){
			//add div to do some measuring
			const measureSpan = document.createElement("span");
			measureSpan.classList.add('textMeasure');
			measureSpan.style.whiteSpace = 'nowrap';
			measureSpan.setAttribute('nowrap', 'nowrap');
			measureSpan.textContent = $this.textContent.trim();
			$this.appendChild(measureSpan);
			
			// var containerWidth = $this.clientWidth;
			var containerWidth = $this.clientWidth * .95;
			// var containerWidth = $this.closest('.fake-container--left').clientWidth * .55;
			// containerWidth = (window.offsetWidth <= 425) ? window.offsetWidth : containerWidth;

			// var rect = document.querySelector('.blinders').getBoundingClientRect();
			// console.log('cw', window.innerWidth, containerWidth);
			
			var textArr = $this.querySelector(".textMeasure").textContent.trim().split(" ");

			const tempSpan = document.createElement("span");
			tempSpan.classList.add('tempMeasure');
			tempSpan.style.whiteSpace = 'nowrap';
			tempSpan.setAttribute('nowrap', 'nowrap');
			$this.appendChild(tempSpan);
			
			var $tempMeasure = $this.querySelector(".tempMeasure");
			var tempText = "";
			var spans = new Array();
			var currentSpan = 0;
			
			//for each word, add it to the tempMeasure and keep measuring that it'll fit
			for(var i=0; i<textArr.length; i++){
				tempText = tempText + " " + textArr[i];
				$tempMeasure.textContent = tempText;
				// console.log('tm', $tempMeasure.offsetWidth, containerWidth);
				if( $tempMeasure.offsetWidth >= containerWidth ){
					tempText = textArr[i]; //start new span
					currentSpan++;
				}
				spans[currentSpan] = tempText;
			}
			
			//for each spans[j], wrap em into <span> and replace $this.html()
			var newHtml = "";
			for(var j=0; j<spans.length; j++){
				if (spans[j]) {
					newHtml = newHtml + '<span class="stack">' + spans[j].trim() + '</span> ';
				}
			}
			$this.innerHTML = newHtml;
		}

	});
	
	//handle manual spans
	$element.querySelectorAll(".blinders span").forEach(function($this){
		$this.classList.add('stack');
	});

	//prop things open so we can reclaim the space the abspos stuff should have taken
	$element.querySelectorAll(".blinders").forEach(function($this){
		var thisStyle = window.getComputedStyle($this),
			lineHeight = thisStyle.getPropertyValue('line-height'),
			numSpans = $this.querySelectorAll(".stack").length;
		// console.log("numSpans: "+ numSpans);
		
		//artifical space for how high the H1 should have been
		$this.style.height = (parseInt(lineHeight)*numSpans) + "px"; 
	});

	//set the blinders visible again
	$element.querySelectorAll(".blinders").forEach(function($this){
		$this.style.visibility = "visible";
		// console.log('on', $element);
	});

	//do the blinders animation
	blinderStackSpans($element);
}

function blinderStackSpans($element){
	// console.log("blinderStackSpans()");
	var blindersOffsetHeight = 0,
		blinderDelay = 0,
		blinderInterval = 250; //millisecond delay between each line reveal

	$element.querySelectorAll(".blinders").forEach(function($this){
		var thisStyle = window.getComputedStyle($this),
			lineHeight = thisStyle.getPropertyValue('line-height'),
			numSpans = $this.querySelectorAll("span.stack").length;

		// console.log("numSpans: "+ numSpans, 'thistyle:'+ lineHeight, thisStyle.top);
		blindersOffsetHeight = (parseInt(lineHeight) * numSpans) - parseInt(lineHeight);
		
		$this.querySelectorAll("span.stack").forEach(function(_this){
			//stack the spans:
			_this.style.bottom = blindersOffsetHeight + "px";
			blindersOffsetHeight = blindersOffsetHeight - parseInt(lineHeight);
			//show each row:
			setTimeout( function(){ blinderReveal(_this, lineHeight); }, blinderDelay );
			blinderDelay += blinderInterval;
		});
		
	});
}

function blinderReveal($span, lineHeight){
	// console.log('start velocity', $span);
	Velocity($span, {height: lineHeight, opacity: 1}, { duration: 250 });
	// console.log('end velocity', $span);
}

function animateCount(start, end, $target, speed) {
	if (!speed) speed = 50;

	if (start === end) {
		return;
	}

	if (start <= end) {
		$target.querySelector('div').innerHTML = start++;
		if (speed < 100) {
			if (end - start > 100) {
				start += 5;
			} else if(end - start > 75) {
				start += 1;
			}
		}
	} else {
		$target.querySelector('div').innerHTML = start--;
		if (speed < 100) {
			if (start - end > 100) {
				start -= 5;
			} else if(start - end > 75) {
				start -= 1;
			}
		}
	}
	setTimeout(() => {
		animateCount(start, end, $target, speed);
	}, speed);
}

var numbersAnimated = false;
function animateNumbers($element) {
	var $percentNum = document.querySelectorAll('.percentage--num');
	if ($percentNum) {
		var delay = 300;
		$percentNum.forEach(function($this) {
			setTimeout(() => {
				const end = parseInt($this.querySelector('div').innerHTML)+1;
				$this.classList.remove('hidden');
				animateCount(0, end, $this, 10);
				numbersAnimated = true;
			}, delay);
			delay += 400;
		});
	}
}

const debounce = (func, wait, immediate) => {
    var timeout;
    return () => {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};